<div class="status-left">
  @if (status) {
    <glxy-uploader-file-status [status]="status" />
  }

  @if (!url) {
    <span class="file-name">{{ name }}</span>
  }
  @if (url) {
    <a class="file-name" [href]="url" rel="noopener noreferrer" target="_blank">
      {{ name }}
    </a>
  }
</div>

@if (deleted.observers.length > 0) {
  <button mat-icon-button (click)="deleteClick()">
    <mat-icon class="delete-button-icon">add_circle_outline</mat-icon>
  </button>
}
